// eslint-disable-next-line import/prefer-default-export
export const getSlideIdFromUrl = (url: string | undefined) => {
  // Extract the slide ID from the lesson's instructor URL.
  //       Possible formats are:
  //       https://docs.google.com/presentation/d/1MAQzFgRbDmo52uf4itsMCSUXDXqX7oVS3DgeFT-V-a8/preview
  //       https://drive.google.com/file/d/1q0RAfZidxqIwdle11-wy-fWYabtswJKK10OSQhvE8iI/preview
  if (!url) {
    return '';
  }
  const regex = /\/d\/([a-zA-Z0-9_-]+)/;
  const match = url.match(regex);
  return match ? match[1] : url;
};
